import SqftJsonApi from "../../../../../../api/sqftJsonApi";
import GenericModelLoader from "./GenericModelLoader";

class WallsLoader extends GenericModelLoader {
  constructor(opts) {
    super(opts);
  }

  async getUrl(data) {
    const cp = await SqftJsonApi.getWall(data, {});
    if (!cp || !cp.s3Url) {
      console.log('No URL for wall at position', data);
      return null;
    }
    return cp.s3Url;
  }

  getModelPosition() {
    return {
      x: 0,
      y: this.modelScale,
      z: 0
    }
  }
}

export default WallsLoader;
